export default class VuetifySettings {
  private name: string
  private base: string
  private btnBgColor?: string
  private btnTxtColor?: string
  private btnBorderRadius: number

  constructor({ name, base, btnBgColor = '', btnTxtColor = '', btnBorderRadius = 0 }) {
    this.name = name
    this.base = base
    if (btnBgColor) {
      this.btnBgColor = btnBgColor
    }
    if (btnTxtColor) {
      this.btnTxtColor = btnTxtColor
    }
    if (btnBorderRadius) {
      this.btnBorderRadius = btnBorderRadius
    }
  }

  public cssProperties() {
    const properties = {}
    properties[`--v-${this.name}-base`] = this.base
    if (this.btnBgColor && this.btnBgColor !== this.base) {
      properties[`--v-${this.name}-btn-bg-color`] = this.btnBgColor
    }
    if (this.btnTxtColor) {
      properties[`--v-${this.name}-btn-txt-color`] = this.btnTxtColor
    }
    if (this.btnBorderRadius) {
      properties[`--v-${this.name}-btn-border-radius`] = this.btnBorderRadius
    }

    return properties
  }
}
